import * as yup from 'yup'

const schema = yup.object().shape({
  idAnimal: yup.string().required('Campo obrigatório.'),
  data: yup.date().required('Campo obrigatório.').typeError('Data inválida.'),
  ocorrencia: yup.string().required('Campo obrigatório.'),
  causa: yup.string().required('Campo obrigatório.'),
  observacao: yup.string()
})

export default schema
